import * as React from 'react';

import { cn } from '@/lib/utils';

const Field = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    orientation?: 'horizontal' | 'vertical';
  }
>(({ className, orientation = 'vertical', ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'rounded-lg border-2 border-dashed border-muted-foreground/50 p-4',
      orientation === 'horizontal' && 'flex items-center justify-between gap-4',
      orientation === 'vertical' && 'flex flex-col gap-2',
      className,
    )}
    {...props}
  />
));
Field.displayName = 'Field';

const FieldLabel = React.forwardRef<
  HTMLLabelElement,
  React.LabelHTMLAttributes<HTMLLabelElement>
>(({ className, ...props }, ref) => (
  <label ref={ref} className={cn('cursor-pointer', className)} {...props} />
));
FieldLabel.displayName = 'FieldLabel';

const FieldContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('flex flex-col gap-1', className)} {...props} />
));
FieldContent.displayName = 'FieldContent';

const FieldTitle = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('text-sm leading-none font-medium', className)}
    {...props}
  />
));
FieldTitle.displayName = 'FieldTitle';

const FieldDescription = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('text-sm text-muted-foreground', className)}
    {...props}
  />
));
FieldDescription.displayName = 'FieldDescription';

export { Field, FieldLabel, FieldContent, FieldTitle, FieldDescription };
